import { Button as ChakraButton, ButtonProps } from "@chakra-ui/react";

const Button = (props: ButtonProps) => <ChakraButton {...props} />;

export default Button;
